// extracted by mini-css-extract-plugin
module.exports = {"navLinkWithCopyText":"NavLinkWithCopyText_navLinkWithCopyText__3muaC","copyIcon":"NavLinkWithCopyText_copyIcon__22mF-"};